module.exports = "/_next/static/images/c0b052c170c452b12a2990f9d0e71e68-holding-card-vertical@3x.png";